import { useQuery } from '@tanstack/react-query';
import * as chatApi from '../../api/chat';
import { chatKeys } from './chatKeys';

export function useChatRoom(roomId: string | null | undefined) {
  return useQuery({
    queryKey: roomId ? chatKeys.room(roomId) : ['chat', 'room', 'disabled'],
    queryFn: () => chatApi.getRoom(roomId!),
    enabled: !!roomId,
    staleTime: 60_000,
  });
}
